import React from 'react';

import BulkActions from './BulkActions';
import UserTableActions from './UserTableActions';

/**
 * @component ActionsSection
 * @description
 * Sección de acciones para la tabla de usuarios, muestra:
 * - Acciones por lote si hay filas seleccionadas.
 * - Botones individuales si no hay selección.
 *
 * @param {Object} selectedRowIds - Objeto con los IDs de las filas seleccionadas.
 * @param {Array} tableRows - Lista completa de filas renderizadas en la tabla.
 * @param {Function} handleShow - Función para abrir el panel de filtros.
 * @param {Function} handleOpen - Función para abrir el modal de nuevo usuario.
 * @param {Function} onExport - Función que exporta los datos seleccionados.
 */
const ActionsSection = ({ selectedRowIds, handleOpen, onBulkAction }) => {
	
	return (
		<div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
			{Object.keys(selectedRowIds).length > 0 ? (
				<BulkActions onBulkAction={onBulkAction} />
			) : (
				<UserTableActions handleOpen={handleOpen} />
			)}
		</div>
	);
};

export default ActionsSection;